import { Body1, UIHeading2 } from '@cian/ui-kit';
import { Button } from '@cian/ui-kit/button';
import { IconActionCompareAdd16 } from '@cian/ui-kit-design-tokens/icons';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';

export type TComparisonEmptyVariant = 'empty' | 'unauthorized';

export interface IComparisonEmptyProps {
  variant: TComparisonEmptyVariant;
  onButtonClick(): void;
}

const TITLES: Record<TComparisonEmptyVariant, string> = {
  empty: 'Пока в списке пусто',
  unauthorized: 'Сравнивайте квартиры и ЖК',
};

export const ComparisonEmpty: React.FC<IComparisonEmptyProps> = ({ variant, onButtonClick }) => {
  return (
    <div className={styles['container']} data-name="ComparisonEmpty">
      <div className={classNames(styles['illustration'], styles[`illustration-${variant}`])} />
      <div className={styles['text']}>
        <UIHeading2>{TITLES[variant]}</UIHeading2>
        <Body1>
          Чтобы сравнить варианты, нажмите{' '}
          <span className={styles['icon']}>
            <IconActionCompareAdd16 color="icon-main-default" />
          </span>{' '}
          на ЖК
        </Body1>
      </div>
      <Button size="M" theme="main_primary" onClick={onButtonClick}>
        Выбрать ЖК
      </Button>
    </div>
  );
};
